var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "visitor-typing" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", [_vm._v(_vm._s(_vm.message) + "...")]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "typing-dots" }, [
      _c("div", { staticClass: "typing-dots-item" }),
      _vm._v(" "),
      _c("div", { staticClass: "typing-dots-item" }),
      _vm._v(" "),
      _c("div", { staticClass: "typing-dots-item" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }